import { useRequiredContext } from "@redotech/react-util/context";
import { useTranslation } from "@redotech/redo-i18n";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoFeatureNotificationCard } from "@redotech/redo-web/arbiter-components/feature-notification/redo-feature-notification-card";
import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { OnboardingProps } from "../common";
import bulkReturnActionsUrl from "./bulk-return-actions.png?url";

export const BulkReturnActionsOnboarding = memo(
  function BulkReturnActionsOnboarding({
    handleDismiss,
    handleComplete,
  }: OnboardingProps) {
    const { t } = useTranslation();
    const routes = useRequiredContext(MerchantRoutesContext);
    const navigate = useNavigate();

    const handleAction = () => {
      navigate(routes.returnsHref);
      handleComplete();
    };

    return (
      <RedoFeatureNotificationCard
        actionText={t("View returns")}
        description={t(
          "Select several returns in the returns table and approve, process, reject, close, flag or tag them together.",
        )}
        image={bulkReturnActionsUrl}
        onAction={handleAction}
        onDismiss={handleDismiss}
        title={t("Process returns in bulk")}
      />
    );
  },
);
